<div *ngIf="errors.length > 0" class="alert alert-danger">
  <strong>Fehler aufgetreten!</strong>
  <p *ngFor="let error of errors">
    {{ error.title }}
  </p>
</div>



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/components/server-errors/server-errors.component.html